import { useTranslation } from 'react-i18next';
import { StudioProjectList } from './components';
import { Header, ProjectsContainer } from './styled';

const LibraryStudioProjects = () => {
  const { t } = useTranslation();

  return (
    <ProjectsContainer>
      <Header data-testid="studio-project-header" variant="h1">
        {t('library:projects:heading')}
      </Header>
      <StudioProjectList />
    </ProjectsContainer>
  );
};

export default LibraryStudioProjects;
